import axios from "axios";
import { getHeader, getToken } from "@/helpers/functions";

const header = getHeader(getToken("ifragasatt_cookie"));
const url = `${process.env.VUE_APP_MY_SETTINGS}`;

const state = {
  myPreferences: {}
};

const getters = {
  myPreferences: state => state.myPreferences
};

const mutations = {
  setMyPreferences: (state, payload) => (state.myPreferences = payload)
};

const actions = {
  getMyPreferences({ commit, dispatch }) {
    dispatch("setIsLoading", true);
    axios
      .get(url, header)
      .then(res => {
        commit("setMyPreferences", res.data);
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.PREFERENCES_FETCH_FAILED", type: "error" });
      })
      .finally(() => {
        dispatch("setIsLoading", false);
      });
  },
  updateMyPreferences({ commit, dispatch }, payload) {
    dispatch("setIsLoading", true);
    axios
      .put(url, payload, header)
      .then(() => {
        commit("setMyPreferences", payload);
      })
      .catch(err => {
        console.error(err);
        dispatch("showToast", { message: "errors.PREFERENCES_UPDATE_FAILED", type: "error" });
      })
      .finally(() => {
        dispatch("setIsLoading", false);
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
